import React from 'react';
import '../styles/main.scss';
import './GTM'; // initializes GTM if GTM-ID is set in env.conf.js
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import Providers from './App/Providers';
import ScrollToTop from './App/ScrollToTop';
import NavigateBackFromIframe from './App/NavigateBackFromIframe';
import DocumentTitle from './App/DocumentTitle';
import PageTracking from './App/PageTracking';
import App from './App';
import { Player } from './App/Components/Player';
import { Audioplayer } from "./Audioplayer";
import { AudioplayerTracking } from './Audioplayer/AudioplayerTracking';
import { AudioplayerPostmessage } from './Audioplayer/AudioplayerPostmessage'; 

window.audioplayer = new Audioplayer();
window.audioplayer.setup();

const audioplayerTracking = new AudioplayerTracking(window.audioplayer);
audioplayerTracking.setup();

const audioplayerPostmessage = new AudioplayerPostmessage();
audioplayerPostmessage.setup();

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <ScrollToTop />
        <DocumentTitle />
        <NavigateBackFromIframe />
        <Providers>
            <App />
            <Player />
            <PageTracking />
        </Providers>
    </BrowserRouter>
);